import { render, staticRenderFns } from "./MetricsManagement.vue?vue&type=template&id=21b9c10e&scoped=true"
import script from "./MetricsManagement.vue?vue&type=script&lang=js"
export * from "./MetricsManagement.vue?vue&type=script&lang=js"
import style0 from "./MetricsManagement.vue?vue&type=style&index=0&id=21b9c10e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9c10e",
  null
  
)

export default component.exports